import { Typography, Paper, Divider } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import { formatRegistrationDate } from '../../../../../components/common/time/timeHelper'

const CheckRegistrationStatus = ({ registrationStatusCheck }) => {
  const { t } = useTranslation(['common', 'messages'])
  const details = registrationStatusCheck?.checkDetails
  const found = registrationStatusCheck?.found

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:registrationStatus', 'Estado Registral')}</Typography>
      </Paper>

      <CheckDetailTitle
        email={registrationStatusCheck?.email}
        status={registrationStatusCheck?.status}
        createdAt={registrationStatusCheck?.createdAt}
        updatedAt={registrationStatusCheck?.updatedAt}
      />

      {found ? (
        <TimelineDotLine>
          <Paper elevation={0} variant="rootOutlined" sx={{ flex: 1 }}>
            <Typography variant="subtitle2" sx={{ mb: 2 }}>{t('common:overview', 'Resumen')}</Typography>
            <div className="c-detail-grid">
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:situacao', 'Situación')}</Typography>
                <Typography variant="subtitle3">{registrationStatusCheck?.situacao ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:code', 'Código')}</Typography>
                <Typography variant="subtitle3">{registrationStatusCheck?.code ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:queryDate', 'Fecha Consulta')}</Typography>
                <Typography variant="subtitle3">{formatRegistrationDate(details?.QueryDate)}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:elapsedMilliseconds', 'Milisegundos')}</Typography>
                <Typography variant="subtitle3">{details?.ElapsedMilliseconds ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:queryId', 'ID Consulta')}</Typography>
                <Typography variant="subtitle3">{details?.QueryId ?? '---'}</Typography>
              </div>
            </div>
            <Divider sx={{ my: 2 }} />
            <Typography variant="subtitle2" sx={{ mb: 2 }}>{t('common:result', 'Resultado')}</Typography>
            {Array.isArray(details?.Result) && details.Result.length > 0 ? (
              details.Result.map((item, idx) => {
                const bd = item.BasicData || {}
                return (
                  <Paper key={idx} elevation={0} variant="rootOutlined" sx={{ mb: 2, p: 1 }}>
                    <div className="c-detail-grid">
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">{t('common:taxIdNumber', 'Tax ID')}</Typography>
                        <Typography variant="subtitle3">{bd.TaxIdNumber ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">{t('common:taxIdCountry', 'País')}</Typography>
                        <Typography variant="subtitle3">{bd.TaxIdCountry ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">{t('common:taxIdType', 'Tipo')}</Typography>
                        <Typography variant="subtitle3">{bd.TaxIdType ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">{t('common:taxIdStatus', 'Estado')}</Typography>
                        <Typography variant="subtitle3">{bd.TaxIdStatus ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">{t('common:taxIdOrigin', 'Origen')}</Typography>
                        <Typography variant="subtitle3">{bd.TaxIdOrigin ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">{t('common:taxIdFiscalRegion', 'Región Fiscal')}</Typography>
                        <Typography variant="subtitle3">{bd.TaxIdFiscalRegion ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">{t('common:name', 'Nombre')}</Typography>
                        <Typography variant="subtitle3">{bd.Name ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">{t('common:gender', 'Género')}</Typography>
                        <Typography variant="subtitle3">{bd.Gender ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">{t('common:birthDate', 'Fecha Nacimiento')}</Typography>
                        <Typography variant="subtitle3">{formatRegistrationDate(bd.BirthDate)}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">{t('common:age', 'Edad')}</Typography>
                        <Typography variant="subtitle3">{bd.Age ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">{t('common:zodiacSign', 'Signo Zodiacal')}</Typography>
                        <Typography variant="subtitle3">{bd.ZodiacSign ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">{t('common:chineseSign', 'Signo Chino')}</Typography>
                        <Typography variant="subtitle3">{bd.ChineseSign ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">{t('common:birthCountry', 'País Nacimiento')}</Typography>
                        <Typography variant="subtitle3">{bd.BirthCountry ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">{t('common:motherName', 'Nombre Madre')}</Typography>
                        <Typography variant="subtitle3">{bd.MotherName ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">{t('common:fatherName', 'Nombre Padre')}</Typography>
                        <Typography variant="subtitle3">{bd.FatherName ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">{t('common:hasObitIndication', 'Obituario')}</Typography>
                        <Typography variant="subtitle3">{bd.HasObitIndication ? t('common:yes') : t('common:no')}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">{t('common:obitIndicationOrigin', 'Origen Obituario')}</Typography>
                        <Typography variant="subtitle3">{bd.ObitIndicationOrigin ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">{t('common:obitIndicationYear', 'Año Obituario')}</Typography>
                        <Typography variant="subtitle3">{bd.ObitIndicationYear ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">{t('common:taxIdStatusDate', 'Fecha Estado')}</Typography>
                        <Typography variant="subtitle3">{formatRegistrationDate(bd.TaxIdStatusDate)}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">{t('common:taxIdStatusRegistrationDate', 'Fecha Registro Estado')}</Typography>
                        <Typography variant="subtitle3">{formatRegistrationDate(bd.TaxIdStatusRegistrationDate)}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">{t('common:creationDate', 'Fecha Creación')}</Typography>
                        <Typography variant="subtitle3">{formatRegistrationDate(bd.CreationDate)}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">{t('common:lastUpdateDate', 'Fecha Última Actualización')}</Typography>
                        <Typography variant="subtitle3">{formatRegistrationDate(bd.LastUpdateDate)}</Typography>
                      </div>
                      {/* Aliases y AlternativeIdNumbers */}
                      {bd.Aliases && (
                        <div className="c-detail-row">
                          <Typography variant="subtitle1">{t('common:aliases', 'Alias')}</Typography>
                          <Typography variant="subtitle3">{Object.values(bd.Aliases).join(', ')}</Typography>
                        </div>
                      )}
                      {bd.AlternativeIdNumbers && (
                        <div className="c-detail-row">
                          <Typography variant="subtitle1">{t('common:alternativeIdNumbers', 'ID Alternativos')}</Typography>
                          <Typography variant="subtitle3">{Object.entries(bd.AlternativeIdNumbers).map(([k, v]) => `${k}: ${v}`).join(', ')}</Typography>
                        </div>
                      )}
                    </div>
                  </Paper>
                )
              })
            ) : (
              <Typography variant="body2">{t('common:noResultsFound', 'No se encontraron resultados.')}</Typography>
            )}
          </Paper>
        </TimelineDotLine>
      ) : (
        <Paper variant="rootOutlined" elevation={0}>
          <Typography variant="subtitle3">{t('common:noDataFound', 'No se encontraron datos.')}</Typography>
        </Paper>
      )}
    </>
  )
}

export default CheckRegistrationStatus
